import React from 'react';

import { CardContent, Card, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { LiveChatNotificationResponseNext } from '@alme/types/response/LiveChatNotificationResponse';
import { EntryExtensionData } from '@alme/types/response/EntryExtensionData';
import { AlmeMarkdownResponseNext } from '../../../AlmeResponse/AlmeResponse';

import liveChatSystemResponseStyles from './AlmeLiveChatSystemResponse.styles';
import { FocusComponentProps } from '../../../../models/ComponentProps';

import { getAgentResponse, getAgentResponseText } from '../../../AlmeResponse/AlmeResponseUtils';
import { AlmeLiveChatSystemResponseConfig } from './AlmeLiveChatSystemResponseConfig';

export function isValidLiveChatSystemResponse(response: LiveChatNotificationResponseNext, isLastResponse: boolean): boolean {
    const responseText = getAgentResponseText(response);
    const hasIvaResponse = !!(responseText);

    return hasIvaResponse && (response?.extensionData?.MessageOrigin === 'System') &&
        (response?.extensionData?.Transient === false || (response?.extensionData?.Transient === true && isLastResponse));
}

interface AlmeLiveChatSystemResponseProps extends WithStyles<typeof liveChatSystemResponseStyles> {
    response: LiveChatNotificationResponseNext;
    isLastResponse: boolean;
    almeConfig: AlmeLiveChatSystemResponseConfig;
    focusProps?: FocusComponentProps;
    responseId?: string | number;
}

const AlmeLiveChatSystemResponse: React.FC<AlmeLiveChatSystemResponseProps> = (props: AlmeLiveChatSystemResponseProps) => {
    const response = {
        ...props.response,
        // TODO: add support for limited markdown in live chat (i.e. URL links).
        html: '',
    } as AlmeMarkdownResponseNext;

    if (!isValidLiveChatSystemResponse(props.response, props.isLastResponse)) {
        return null;
    }

    const responseText = getAgentResponse(response, props.classes.systemBodyText, props.classes.inlineButton);
    const responseRevision = (props.responseId || response.responseRevision).toString();
    const entryId = response.id || (response.extensionData && (response.extensionData as EntryExtensionData)?.entryId) || responseRevision;

    return (
        <div
            key={`${entryId}-system`}
            className={props.classes.systemCardContainer}
            id={`alme-system-live-chat-card-${responseRevision}`}>
            <Card
                className={props.classes.systemCard}
                key={`${entryId}-system`}
                raised={props.isLastResponse}
            >
                <CardContent className={props.classes.systemCardContent}>
                    <Typography variant="caption" className={props.classes.systemCardBody}>{responseText}</Typography>
                </CardContent>
            </Card>
        </div>
    );
};

export default withStyles(liveChatSystemResponseStyles)(AlmeLiveChatSystemResponse);
